define('gigaset/spinner',[
	"jquery"
], function(
	$
) {

	function Spinner () {
		this.selector = '.spinner-container';
		this.template = $('<div class="spinner-container"><div class="spinner-bounce">'
			+ '<div class="double-bounce1"></div>'
			+ '<div class="double-bounce2"></div>'
			+ '</div></div>');
		this.transitionTime = 300;
		this.defaultContainer = 'body';
	}

	Spinner.prototype = {

		template: null,
		selector: null,
		transitionTime: null,
		defaultContainer: null,

		add: function(container) {
			container = container || this.defaultContainer;
			$(container).prepend((this.template).hide().fadeIn(this.transitionTime));
		},
		remove: function(container) {
			container = container || this.defaultContainer;
			$(this.selector, container).fadeOut(this.transitionTime, function() {
				$(this).remove();
			} );
		}
	};

	return new Spinner;

});
